export interface WorkingtimeArray {
  id: number;
  employeeCode: number;
  employeeName: string;
  date: string;
  workingTime: string;
  productiveHours: string;
  unproductiveHours: string;
  productiveRatio: string;
  weekdayWorkingTime: string;
  weekdayOvertime: string;
  weekendWorkingTime: string;
}

export type WorkingtimeGetResponse = {
  items: WorkingtimeArray[];
  page: number;
  totalPages: number;
};

export const EmptyWorkingtimeGetResponse: WorkingtimeGetResponse = {
  items: [
    {
      id: 0,
      employeeCode: 0,
      employeeName: '',
      date: '',
      workingTime: '',
      productiveHours: '',
      unproductiveHours: '',
      productiveRatio: '',
      weekdayWorkingTime: '',
      weekdayOvertime: '',
      weekendWorkingTime: '',
    },
  ],
  page: 1,
  totalPages: 0,
};
